<template>
  <v-dialog :value="value" width="500px" persistent @input="$emit('input', false)">
    <v-card>
      <v-card-title>
        <span class="section-title">Trocar senha</span>
      </v-card-title>
      <v-card-text>
        <v-row class="py-0">
          <v-col class="py-1">
            <span class="card-title pl-0">{{ user.name }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-1">
            <span class="card-title pl-0">{{ user.document_no | cpfCnpj }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-3">
            <v-text-field
              v-model="password"
              autofocus
              outlined
              data-cy="userPassword"
              label="Nova senha"
              :type="visible ? 'text' : 'password'"
              :error-messages="error"
              hide-details
              @focus="passFocus = true"
              @blur="passFocus = false"
            >
              <template #append>
                <span>
                  <mf-icon
                    class="cursor-pointer"
                    :color="passFocus ? 'marca-0' : 'cinza-0'"
                    :icon="visible ? 'visibility_off' : 'visibility'"
                    @click="() => (visible = !visible)"
                  />
                </span>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0">
            <v-text-field
              v-model="confirmPassword"
              outlined
              data-cy="userConfirmPassword"
              label="Confirmar nova senha"
              :type="visible ? 'text' : 'password'"
              :error-messages="error"
              @focus="passCheckFocus = true"
              @blur="passCheckFocus = false"
            >
              <template #append>
                <span>
                  <mf-icon
                    class="cursor-pointer"
                    :color="passCheckFocus ? 'marca-0' : 'cinza-0'"
                    :icon="visible ? 'visibility_off' : 'visibility'"
                    @click="() => (visible = !visible)"
                  />
                </span>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <mf-action-buttons
          class="mt-2"
          :primary-button="{
            text: 'Salvar',
            action: save,
            isVisible: true,
            isLoading: loading,
          }"
          :extra-button="{
            text: 'Cancelar',
            action: () => $emit('input', false),
            isVisible: true,
            isDisabled: loading,
          }"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Swal from 'sweetalert2'
import { required, sameAs, minLength } from 'vuelidate/lib/validators'
import { MUTATION_CHANGE_PASSWORD } from '@/modules/clientes/gerenciamento/graphql'

export default {
  props: {
    value: Boolean,
    user: Object,
  },
  data: () => ({
    password: '',
    confirmPassword: '',
    loading: false,
    visible: false,
    passFocus: false,
    passCheckFocus: false,
  }),
  computed: {
    error() {
      if (this.$v.password.$error) return 'A senha deve ter no mínimo 6 letras'
      if (this.$v.confirmPassword.$error) return 'A confirmação de senha deve ser igual à senha'
      return ''
    },
  },
  watch: {
    value() {
      this.password = ''
      this.confirmPassword = ''
      this.visible = false
      this.$v.$reset()
    },
  },
  methods: {
    async save() {
      this.$v.$touch()
      if (this.$v.$error) {
        return
      }

      const confirmed = await this.$confirm({
        tilte: 'Salvar alterações',
        message:
          'Todas as alterações serão disponibilizadas no aplicativo imediatamente, e na plataforma após a próxima atualização.  Deseja realmente fazer essa alteração?',
        confirmText: 'Salvar',
        confirmColor: 'primary',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return

      this.loading = true
      try {
        await this.$apollo.mutate({
          mutation: MUTATION_CHANGE_PASSWORD,
          variables: {
            _id: this.user._id,
            password: this.password,
          },
        })
        this.loading = false
        Swal.fire({
          text: 'Senha alterada',
          icon: 'success',
          showConfirmButton: false,
          timer: 1000,
          customClass: {
            content: 'content-class',
          },
        })
        this.$emit('input', false)
      } catch (e) {
        this.$snackbar({ message: 'Ocorreu um erro ao alterar senha' })
        this.loading = false
      }
    },
  },
  validations() {
    return {
      password: {
        required,
        minLength: minLength(6),
      },
      confirmPassword: {
        sameAsPassword: sameAs('password'),
      },
    }
  },
}
</script>
